import React, { useState } from "react";
import { Body, Box, Link } from "@iris/react-components";
import { sendClick } from 'reaxl-analytics';
import ChangeStateModal from "./ChangeStateModal";

type ChangeStateFooterProps = {
  text: string;
  selectedState: string;
  currentZip: string;
  onSave: (zip: string) => Promise<void>;
  modalText: string;
};

export default function ChangeStateFooter({ 
  text, 
  selectedState, 
  currentZip, 
  onSave,
  modalText 
}: ChangeStateFooterProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChangeClick = (e?: React.MouseEvent) => {
    e?.preventDefault();

    // Pixall Event C3. Change State Link
    const pixallData = {
      hasListingType: false,
      label: 'text-link::change-state',
      eventSource: 'link',
      pageId: 'slp_psx_buy',
      cdl: {
          event: {
              action: 'Click',
              element: 'Change State Link',
              tagIndex: 'psx-122',
          },
      },
    };
    sendClick('sycClickEvent', e, {
        isPixallEvent: true,
        pixallData,
    });

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box className="fees-footer" data-testid="change-state-footer">
        {/* iris-override (token unavailable): Body lacks mb=0 prop; using iris:!mb-0 to remove default paragraph margin */}
        <Body as="p" className="iris:text-(--base-color-neutral-600) iris:!mb-0 iris:text-[14px] iris:md:text-[16px] iris:text-left iris:md:text-center">
          {text} {selectedState}
          {". "}
          {/* iris-override (token unavailable): Link variant="standalone" resets color in hover/active; using iris:! color overrides to maintain brand color */}
          <Link
            variant="standalone"
            className="iris:inline-flex iris:text-[14px] iris:md:text-[16px] iris:!text-(--base-color-primary-600) hover:iris:!text-(--base-color-primary-600) active:iris:!text-(--base-color-primary-600)"
            onClick={handleChangeClick}
          >
            Change State
          </Link>
        </Body>
      </Box>

      <ChangeStateModal
        text={modalText}
        isOpen={isModalOpen}
        currentZip={currentZip}
        onClose={handleCloseModal}
        onSave={onSave}
      />
    </>
  );
}
